import React from "react"
import { withRouter } from 'react-router-dom'
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import { Form, Col, Row, Card, Tag, Spin, Button, Table, Input, message, Select } from "antd"
import { API, Auth } from "aws-amplify"
import { connect } from "react-redux"
import { CustomSpinner } from "../../Components/Spin/CustomSpiner"
import DocumentTable from "../../Components/Documents/DocumentTable";
import EditDocument from "../../Components/Documents/EditDocument";
import CandidateForm from "../../Components/Documents/CandidateForm";

class EditCandidate extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            loading: true,
            candidate: {},
            step: 'candidateView',
            documentView: null,
        }
        this.editDocument = this.editDocument.bind(this)
    }

    componentDidMount() {
        this.setState({ candidate: this.props.candidate, loading: false });
    }

    editDocument(document) {
        this.setState({documentView: document, step: 'documentView'}, () => {console.log(document)})
    }

    render() {

        if (this.state.loading) {
            return (
                <>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </>
            )
        } else if (this.state.step === "candidateView") {
            return (
                <>
                <Row>
                    <Col lg={16} xs={24}>
                        <DocumentTable
                            editDocument={this.editDocument}
                            candidate_id={this.state.candidate.candidate_id}
                        />
                    </Col>

                    <Col lg={8} xs={24}>
                        <CandidateForm
                            candidate={this.state.candidate}
                        />
                    </Col>
                </Row>

                <Button
                    type="primary"
                    onClick={() => this.props.handleStep('candidateList')}
                    style={{marginTop: '10px'}}>
                        Volver
                </Button>
                </>
            )
        } else if (this.state.step === 'documentView') {
            return (
                <>
                    <EditDocument document={this.state.documentView}/>
                    <Button type="primary" onClick={() => this.setState({step: 'candidateView', documentView: null })}
                            style={{marginTop: '10px'}}>Volver</Button>
                </>
            )
        }
    }
}

const EditCandidateComponent = Form.create({ name: 'editCandidate' })(EditCandidate);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditCandidateComponent));